const TG_BACKGROUND_COLOR = '#FFFFFF';
const TG_HEADER_COLOR = '#000000';

const THEME_PARAMS_MAP: Record<string, string> = {
  bg_color: '--tg-bg-color',
  text_color: '--tg-text-color',
  hint_color: '--tg-hint-color',
  link_color: '--tg-link-color',
  button_color: '--tg-button-color',
  button_text_color: '--tg-button-text-color',
  secondary_bg_color: '--tg-secondary-bg-color',
  header_bg_color: '--tg-header-bg-color',
  accent_text_color: '--tg-accent-text-color',
  section_bg_color: '--tg-section-bg-color',
  section_header_text_color: '--tg-section-header-text-color',
  subtitle_text_color: '--tg-subtitle-text-color',
  destructive_text_color: '--tg-destructive-text-color',
};

function syncThemeParams(): void {
  const root = document.documentElement;
  const params = window?.Telegram?.WebApp?.themeParams;
  if (!params) return;

  for (const [key, cssVar] of Object.entries(THEME_PARAMS_MAP)) {
    const value = params[key];
    if (value) {
      root.style.setProperty(cssVar, value);
    }
  }
}

export const setupTelegramColors = (): void => {
  const webapp = window?.Telegram?.WebApp;
  if (!webapp) return;

  webapp.setBackgroundColor(TG_BACKGROUND_COLOR);
  webapp.setHeaderColor(TG_HEADER_COLOR);

  syncThemeParams();

  if (webapp.onEvent) {
    webapp.onEvent('themeChanged', syncThemeParams);
  }
};
